'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cbSlideshow = require('./cb-slideshow.controller');

var _cbSlideshow2 = _interopRequireDefault(_cbSlideshow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



function cbSlideshowPane() {
    return {
        restrict: 'E',
        require: '^^cbSlideshow',
        transclude: true,
        link: function link(scope, element, attrs, cbSlideshowController) {
            cbSlideshowController.addSlide(scope, element[0].firstChild);
        },
        scope: {},
        template: "<div class=\"cb-slideshow-pane\"\r\n     data-ng-class=\"selected ? 'cb-slideshow-pane-shown' : 'cb-slideshow-pane-hidden'\"\r\n     data-ng-style=\"css\">\r\n    <div ng-transclude>\r\n\r\n    </div>\r\n</div>\r\n"
    };
}

exports.default = cbSlideshowPane;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/slideshow/cb-slideshow-pane.directive.js
// module id = 911
// module chunks = 0